import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { APIResult } from '@shared/Frontend/utils/apiResult'
import { AsyncState, Template, Unit, unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { getPictures } from './monadsTest.api'
import { MonadsTestState, PictureAPIResponse, PictureWithFlags } from './monadsTest.state'

export type MonadsTestView = {
  Loader: () => ReactNode
  Pictures: (_: { pictureWithFlags: PictureWithFlags[] }) => ReactNode
  Error: (_: { status: number; message: string }) => ReactNode
}

export const MonadsTestTemplate = Template.Default<Unit, MonadsTestState, Unit, MonadsTestView>(
  ({ context, setState, view }) => (
    <>
      <PictureLoaderTemplate
        context={{ ...context, promise: getPictures }}
        setState={setState}
        foreignMutations={unit}
        view={unit}
      />
      {AsyncState.Operations.hasValue(context) ? (
        APIResult.Operations.hasValue(context.value) ? (
          <view.Pictures pictureWithFlags={context.value.v} />
        ) : (
          <view.Error message={context.value.v.message} status={context.value.v.status} />
        )
      ) : (
        <view.Loader />
      )}
    </>
  )
)

const PictureLoaderTemplate = AsyncLoaderTemplate<PictureAPIResponse>()
